import React from 'react';
import { Mail } from 'lucide-react';
import PrimaryButton from '../../themed/PrimaryButton';
import { NotificationSelectorModal } from '../../NotificationSelectorModal';
import { Table } from '../types';

interface NotificationPanelProps {
  tables: Table[];
  loading: boolean;
  notificationLoading: boolean;
  showNotificationModal: boolean;
  setShowNotificationModal: (show: boolean) => void;
  sendingProgress: { current: number; total: number };
  assignedGuests: number;
  onTableNotification: () => void;
  onSendNotifications: (selectedTables: number[] | 'all') => void;
}

export const NotificationPanel: React.FC<NotificationPanelProps> = ({
  tables,
  loading,
  notificationLoading,
  showNotificationModal,
  setShowNotificationModal,
  sendingProgress,
  assignedGuests,
  onTableNotification,
  onSendNotifications,
}) => {
  return (
    <>
      <PrimaryButton
        onClick={onTableNotification}
        disabled={loading || notificationLoading || assignedGuests === 0}
        className="flex items-center space-x-2 bg-violet-400 hover:bg-violet-600 disabled:opacity-50"
      >
        <Mail className={`h-4 w-4 ${notificationLoading ? 'animate-pulse' : ''}`} />
        <span>
          {notificationLoading
            ? sendingProgress.total > 0
              ? `發送中... (${sendingProgress.current}/${sendingProgress.total})`
              : '發送中...'
            : '桌號通知'}
        </span>
      </PrimaryButton>

      <NotificationSelectorModal
        isOpen={showNotificationModal}
        onClose={() => setShowNotificationModal(false)}
        tables={tables}
        onSendNotifications={onSendNotifications}
        loading={notificationLoading}
      />
    </>
  );
};
